package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.css.autoLength
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.AnimationTimingFunction.Companion.cubicBezier
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.gridTemplateColumns
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.lennycodes.hldi.constants.HLDITheme

val TimelineItem = CssStyle {
    base {
        Modifier
            .position(Position.Relative)
            .margin(bottom = 60.px)
            .width(100.percent)
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Row)  // explicit, don't rely on default
    }
}

val TimelineItemLeft = CssStyle {
    base {
        Modifier
            .justifyContent(JustifyContent.FlexStart)
    }
}

val TimelineItemRight = CssStyle {
    base {
        Modifier
            .justifyContent(JustifyContent.FlexEnd)
    }

    (Breakpoint.ZERO until Breakpoint.LG) {
        Modifier
            .justifyContent(JustifyContent.FlexStart)
            .padding(left = 60.px)
    }
}

val TimelineCardLeft = CssStyle {
    Breakpoint.LG {
        Modifier
            .margin(right = 5.percent)
    }
}

val TimelineCardRight = CssStyle {
    Breakpoint.LG {
        Modifier
            .margin(left = 5.percent)
    }
}





val TimelineContainer = CssStyle {
    base {
        Modifier
            .position(Position.Relative)
            .maxWidth(760.px)
            .margin(0.px,autoLength)
            .padding(48.px, 20.px)
    }
}

val TimelineRow = CssStyle {
    base {
        Modifier
            .position(Position.Relative)
            .display(DisplayStyle.Grid)
            .styleModifier {
                gridTemplateColumns("120px 1fr")
            }

            .gap(28.px)
            .padding(28.px, 20.px)
            .borderRadius(10.px)
            .transition(
                Transition.all(
                    duration = 0.3.s,
                    timingFunction = TransitionTimingFunction.cubicBezier(0.22, 1.0, 0.36, 1.0
                )
            )
            )
    }

    hover {
        Modifier
            .backgroundColor(Color.rgba(15, 23, 42, 0.02f))
    }

    (Breakpoint.ZERO until Breakpoint.MD) {
        Modifier
            .styleModifier {
                property("grid-template-columns", "1fr")
            }

            .gap(12.px)
            .gap(8.px)
    }
}

val TimelineAccentBar = CssStyle {
    base {
        Modifier
            .position(Position.Absolute)
            .left(0.px)
            .top(28.px)
            .bottom(28.px)
            .width(3.px)
            .borderRadius(2.px)
            .backgroundColor(HLDITheme.Colors.accent)
            .opacity(0)
        .transition(
            Transition.all(
                duration = 0.25.s,
                timingFunction = TransitionTimingFunction.Ease
            )
        )
    }
}

val TimelineYearBadge = CssStyle {
    base {
        Modifier
            .fontSize(30.px)
            .fontWeight(700)
            .lineHeight(1)
            .color(HLDITheme.Colors.primary)
            .fontFamily("Playfair Display", "serif")
    }
}

val TimelineDivider = CssStyle {
    base {
        Modifier
            .border { width(0.px) }
            .styleModifier {
                property("border-top", "1px dashed ${HLDITheme.Colors.accent}")
            }
            .margin(0.px)
    }
}

val TimelineEventText = CssStyle {
    base {
        Modifier
            .fontSize(16.px)
            .lineHeight(1.7)
            .color(HLDITheme.Colors.text)
            .margin(0.px)
    }
}